import { createFileRoute } from "@tanstack/react-router";
import { RaidList } from "../../raids/RaidList.tsx";

export const Route = createFileRoute("/raids")({
  component: () => <RaidList />,
});
